/**
 * Repository for storing the promoter associated with a customer during registration or login,
 * so it can be sent when the customer makes their first purchase.
 */
export abstract class PromoterRepo {
    public abstract save(promoter: string): void;
    public abstract get(): string | null;
    public abstract delete(): void;
}
